(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sticky-message"] && !Shopify.designMode) return;
  try {
    (function () {
  var container = document.querySelector('.sticky-message');
  if (!container) return;

  var sliderContent = container.querySelector('.slider-content');
  var slides = Array.prototype.slice.call(container.querySelectorAll('.slider-text'));
  if (!sliderContent || slides.length === 0) return;

  var currentIndex = 0;
  var hasTimer = false;
  var timerId = null;

  function cacheSlideSources() {
    var i;
    for (i = 0; i < slides.length; i += 1) {
      var slide = slides[i];
      var source = slide.getAttribute("data-source") || slide.textContent;
      slide.setAttribute("data-source", source);
      if (source.indexOf("[timer]") !== -1) {
        hasTimer = true;
      }
    }
  }

  function getNextMiddayOrMidnight() {
    var now = new Date();
    var midday = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 12, 0, 0);
    var midnight = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1, 0, 0, 0);
    if (now > midday && now < midnight) {
      return (midnight.getTime() - now.getTime()) / 1000;
    }
    return (midday.getTime() - now.getTime()) / 1000;
  }

  function formatTimer() {
    var timer = getNextMiddayOrMidnight();
    var hours = parseInt(timer / 3600, 10);
    var minutes = parseInt((timer % 3600) / 60, 10);
    var seconds = parseInt(timer % 60, 10);
    hours = hours < 10 ? "0" + hours : "" + hours;
    minutes = minutes < 10 ? "0" + minutes : "" + minutes;
    seconds = seconds < 10 ? "0" + seconds : "" + seconds;
    return hours + ":" + minutes + ":" + seconds;
  }

  function renderDynamicText() {
    if (!hasTimer) return;

    var timerText = formatTimer();
    var i;
    for (i = 0; i < slides.length; i += 1) {
      var slide = slides[i];
      var source = slide.getAttribute("data-source") || slide.textContent;
      var nextText = source.replace("[timer]", timerText);
      if (slide.textContent !== nextText) {
        slide.textContent = nextText;
      }
    }
  }

  function goToNext() {
    var i;
    for (i = 0; i < slides.length; i += 1) {
      slides[i].style.display = i === currentIndex ? "inline" : "none";
    }
    currentIndex = (currentIndex + 1) % slides.length;
  }

  function startTimer() {
    if (!hasTimer || timerId || document.hidden) return;
    timerId = setInterval(renderDynamicText, 1000);
  }

  function stopTimer() {
    if (!timerId) return;
    clearInterval(timerId);
    timerId = null;
  }

  cacheSlideSources();
  renderDynamicText();
  goToNext();

  if (slides.length > 1) {
    sliderContent.addEventListener('animationiteration', goToNext);
  }

  if (hasTimer) {
    startTimer();
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) {
        stopTimer();
      } else {
        renderDynamicText();
        startTimer();
      }
    });
  }
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["typewritter"] && !Shopify.designMode) return;
  try {
    (function () {
  /* requestIdleCallback polyfill (ES compatible) */
  window.requestIdleCallback = window.requestIdleCallback || function (cb) {
    return setTimeout(function () {
      cb({ didTimeout: false, timeRemaining: function () { return 1; } });
    }, 1);
  };
  window.cancelIdleCallback = window.cancelIdleCallback || function (id) {
    clearTimeout(id);
  };

  function typewriterLoad(callback) {
    if (typeof callback === "function") callback();
  }

  (function typewriterBoot() {
    function typewriterStartBoot() {
      if ("requestIdleCallback" in window) {
        window.requestIdleCallback(function () {
          typewriterLoad(typewriterInit);
        });
      } else {
        setTimeout(function () {
          typewriterLoad(typewriterInit);
        }, 0);
      }
    }

    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", typewriterStartBoot, { once: true });
    } else {
      typewriterStartBoot();
    }
  })();

  /* ---------- TypewriterLite ---------- */
  function typewriterCreate(el, opts) {
    var state = {
      el: el,
      opts: typewriterMergeOptions(
        {
          strings: [],
          loop: true,
          typeDelayRange: [50, 80],
          deleteDelayRange: [12, 24],
          pauseAfterWord: 1500,
          pauseAfterDelete: 1000,
          cursor: "\u258C"
        },
        opts || {}
      ),
      iWord: 0,
      iChar: 0,
      deleting: false,
      stopped: true,
      timer: 0,
      cursorEl: null
    };

    if (!state.el) return typewriterCreateNoop();

    // accessibility + layout
    state.el.setAttribute("role", "status");
    state.el.setAttribute("aria-live", "polite");
    state.el.style.whiteSpace = "pre";

    // cursor
    if (state.opts.cursor) {
      state.cursorEl = document.createElement("span");
      state.cursorEl.textContent = state.opts.cursor;
      state.cursorEl.style.opacity = "1";
      state.cursorEl.style.transition = "opacity 140ms linear";
      state.el.appendChild(state.cursorEl);
      typewriterBlink(state);
    }

    function start() {
      if (!state.opts.strings.length || !state.el || !state.stopped) return;
      state.stopped = false;
      typewriterSchedule(state, 0);
    }

    function stop() {
      state.stopped = true;
      if (state.timer) clearTimeout(state.timer);
    }

    return {
      start: start,
      stop: stop,
      getState: function () { return state; } // optional
    };
  }

  /* ---------- helpers ---------- */
  function typewriterCreateNoop() {
    return { start: function () {}, stop: function () {}, getState: function () { return null; } };
  }

  function typewriterMergeOptions(base, extra) {
    var out = {};
    var k;
    for (k in base) if (Object.prototype.hasOwnProperty.call(base, k)) out[k] = base[k];
    for (k in extra) if (Object.prototype.hasOwnProperty.call(extra, k)) out[k] = extra[k];
    return out;
  }

  function typewriterRandInt(range) {
    var a = range[0], b = range[1];
    return Math.floor(Math.random() * (b - a + 1)) + a;
  }

  function typewriterSetText(state, t) {
    if (state.cursorEl) {
      if (state.cursorEl.parentNode === state.el) state.el.removeChild(state.cursorEl);
      state.el.textContent = t;
      state.el.appendChild(state.cursorEl);
    } else {
      state.el.textContent = t;
    }
  }

  function typewriterTick(state) {
    if (state.stopped) return;

    var strings = state.opts.strings || [];
    var full = strings[state.iWord] || "";
    var shown = full.slice(0, state.iChar);
    typewriterSetText(state, shown);

    if (!state.deleting) {
      if (state.iChar < full.length) {
        state.iChar++;
        typewriterSchedule(state, typewriterRandInt(state.opts.typeDelayRange));
      } else {
        state.deleting = true;
        typewriterSchedule(state, state.opts.pauseAfterWord);
      }
    } else {
      if (state.iChar > 0) {
        state.iChar--;
        typewriterSchedule(state, typewriterRandInt(state.opts.deleteDelayRange));
      } else {
        state.deleting = false;
        state.iWord = (state.iWord + 1) % strings.length;
        if (!state.opts.loop && state.iWord === 0) {
          state.stopped = true;
          return;
        }
        typewriterSchedule(state, state.opts.pauseAfterDelete);
      }
    }
  }

  function typewriterSchedule(state, delay) {
    if (state.timer) clearTimeout(state.timer);

    function run() {
      requestAnimationFrame(function () {
        typewriterTick(state);
      });
    }

    if ("requestIdleCallback" in window) {
      state.timer = setTimeout(function () {
        window.requestIdleCallback(run, { timeout: 50 });
      }, delay);
    } else {
      state.timer = setTimeout(run, delay);
    }
  }

  function typewriterBlink(state) {
    if (!state.cursorEl) return;

    function flip() {
      if (state.stopped) return;
      state.cursorEl.style.opacity = state.cursorEl.style.opacity === "1" ? "0" : "1";
      setTimeout(function () {
        requestAnimationFrame(flip);
      }, 520);
    }

    requestAnimationFrame(flip);
  }

  /* ---------- init ---------- */
  function typewriterInit() {
    var app = document.getElementById("subtitle-typewriter");
    if (!app) return;

    var rawNames = app.getAttribute("data-typewriter-names") || "";
    var starNames = rawNames.split(/\|/);

    starNames = starNames
      .map(function (name) { return (name || "").trim(); })
      .filter(function (name) { return name.length; });

    var namesForTypewriter = starNames.map(function (name) { return name; });

    var typer = typewriterCreate(app, {
      strings: namesForTypewriter,
      loop: true
    });

    typer.start();
    window.__subtitleTypewriter = typer;
  }
})();
  } catch(e) { console.error(e); }
})();

})();
